import React from 'react';
import FontAwesome from 'react-fontawesome';

interface Props {
    text: string;
    link?: string;
    icon: string;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const RoundedCallout: React.StatelessComponent<Props> = (props: Props) => {
    return(
        <div className={`rounded-box d-flex flex-row ${props.className}`} onClick={props.onClick}>
            <div className="left flex-grow-1">
                <a href={props.link}>{props.text}</a>
            </div>
            <div className="right">
                <FontAwesome name={props.icon}/>
            </div>
        </div>
    );
};

export default RoundedCallout;



// WEBPACK FOOTER //
// ./src/components/global/application/nav/RoundedCallout.tsx